import { sameKey } from '../lib/keys'

/** Port of BoardTabs / TabPlacement / FollowedLink / TabOrder. Row order is
 * left pane then right pane; queries and anchors do not identify a page. */
export const page = (path: string) => path.split(/[?#]/)[0] || '/'
export function samePage(a: string, b: string) {
  a = page(a); b = page(b)
  return a === b || a.startsWith('/') && b.startsWith('/') && sameKey(a.slice(1), b.slice(1))
}
export const isRequest = (path: string) => /^\/r\/[^/]+$/.test(page(path))
const needsYou = (path: string) => page(path) === '/' || isRequest(path)
export interface PlacementTab { page: string | null; blank: boolean; unsaved: boolean }
export type Placement = { type: 'select' | 'take'; index: number } | { type: 'new' }
export function placement(path: string, tabs: PlacementTab[]): Placement {
  const same = tabs.findIndex(tab => tab.page !== null && samePage(tab.page, path))
  if (same >= 0) return { type: 'select', index: same }
  if (isRequest(path)) {
    const inbox = tabs.findIndex(tab => !tab.blank && !tab.unsaved && tab.page !== null && needsYou(tab.page))
    if (inbox >= 0) return { type: 'take', index: inbox }
  }
  const blank = tabs.findIndex(tab => tab.blank)
  return blank >= 0 ? { type: 'take', index: blank } : { type: 'new' }
}
export function followedLink(path: string, opener: number, tabs: PlacementTab[]): Placement | { type: 'here' } {
  const result = placement(path, tabs)
  return result.type !== 'new' && result.index === opener ? { type: 'here' } : result
}
export function tabAnchor(opener: string, opened: string[], row: string[]): number | null {
  const start = row.indexOf(opener)
  if (start < 0) return null
  for (let index = row.length - 1; index > start; index--) if (opened.includes(row[index]!)) return index
  return start
}
